export const minutesToHours = (minutes: number) =>
  Math.round((minutes / 60) * 10) / 10;
